export default __webpack_public_path__ + "static/media/2190.25015dc1.png";